import { Metrics } from '../../../constants/Dashboards'
import { ActionsTypes } from '../../types'
import generateActionTypes from '../generateActionTypes'

const arkMetrics: Metrics[] = [
    Metrics.ARK_BUTTONS,
    Metrics.ARK_DWELL_TIME_SKU,
    Metrics.ARK_NO_INTERACTIONS_SKU,
    Metrics.ARK_SESSIONS_SKU,
    Metrics.ARK_TOP_STORES,
]

const actionTypes: ActionsTypes = generateActionTypes(arkMetrics)

export type ArkActionTypes = typeof actionTypes

export default actionTypes
